import Card from "./Card";
import PageHeader from "./PageHeader";
import Banner from "./Banner";

export default function BackendPending({ title, purpose, endpoints = [], flag }) {
  return (
    <div className="page">
      <PageHeader title={title} subtitle={purpose} />
      <Banner tone="info" title="Waiting for backend endpoints">
        This screen is ready in the frontend, but the PMS backend does not provide these APIs yet. When they are
        available, set <code>{flag}=true</code> in the frontend <code>.env</code> file and rebuild.
      </Banner>
      <Card title="Endpoints this screen needs" padded={false}>
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr><th>Method</th><th>Path</th><th>Used for</th></tr>
            </thead>
            <tbody>
              {endpoints.map(([method, path, use]) => (
                <tr key={`${method} ${path}`}>
                  <td><span className="tag">{method}</span></td>
                  <td><code>{path}</code></td>
                  <td>{use}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
